import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./ManageParish.module.css";
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ManageParish = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
   const [showTransferModal, setShowTransferModal] = useState(false);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [tableData7, setTableData7] = useState([]);
  const [tableData6, setTableData6] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [transferParishId, setTransferParishId] = useState(null);
  const handleOpenModal = (item) => {
    console.log("Prepopulating with:", item); // Debugging check

    // 1. Save the Parish ID (for the API call later)
    setTransferParishId(item.id); 

    // 2. Set Continent
    // We set the ID (7). The <Select> will look into tableData10 to find "BROOKES CONTINENT"
    if (item.continent_id) {
        setSelectedContinent(item.continent_id);
        fetchSubContinents(item.continent_id); 
    }

    // 3. Set Region
    if (item.region_id) {
        setSelectedRegion(item.region_id);
        fetchSubRegions(item.region_id);
    }

    // 4. Set Province
    if (item.province_id) {
        setSelectedProvince(item.province_id);
        // Fetch Zones for this province
        fetchSubProvinces(item.province_id);
    }

    // 5. Set Zone
    if (item.zone_id) {
        setSelectedZone(item.zone_id);
        // Fetch Areas for this zone
        fetchSubZones(item.zone_id);
    }

    // 6. Set Area
    if (item.area_id) {
        setSelectedArea(item.area_id);
    }

    // 7. Show the modal
    setShowTransferModal(true);
};
const handleCloseModal = () => setShowTransferModal(false);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);
  const [areas1, setAreas1] = useState([]);
  const [admin, setAdmin] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedZone1, setSelectedZone1] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedArea1, setSelectedArea1] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [processLoading1, setProcessLoading1] = useState(false);
  const [fetchMode, setFetchMode] = useState('default'); // 'default' or 'area'

 

  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      // fetchUsers(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      // fetchUsers(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      // fetchUsers(page);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');
      const value3 = await localStorage.getItem('admin');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

 

    const fetchSubContinents = async (selectedContinent) => {
      setIsLoading1(true);
  
      try {
        const response = await axios.get(`${BASE_URL1}/continents/getcontinentregions?continent_id=${selectedContinent}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TOKEN}`,
            },
          });
  
        // console.log(response);
        const subCont = response.data?.data;
        const optionss = subCont.map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setTableData4(optionss);
        // console.log(subCont, "heeeer");
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData4([]);
      } finally {
        setIsLoading1(false);
      }
    };

     useEffect(() => {
        if (TOKEN && selectedContinent) {
          fetchSubContinents(selectedContinent);
        }
      }, [TOKEN, selectedContinent]);

    const fetchSubZones = async (selectedZone) => {
      setIsLoading(true);
   
      try {
        const response = await axios.get(`${BASE_URL}/zones/getareaszone?zone_id=${selectedZone}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearer}`,
            },
          });
  
        // console.log(response);
        const subReg = response.data?.data;
        setTableData7(subReg);
        // console.log(subCont, "heeeer");
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData7([]);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
        if (bearer && selectedZone) {
          fetchSubZones(selectedZone);
        }
      }, [bearer, selectedZone]);

        const fetchSubProvinces = async () => {
          setIsLoading(true);
         
          try {
            const response = await axios.get(`${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${TOKEN}`,
                },
              });
      
            // console.log(response);
             const zoneList = response.data?.data || [];
              const formatted = zoneList.map((item) => ({
              label: item.description,
              value: item.id,
            }));
            // setTableData6(subReg);
            setTableData6(formatted);
            // console.log(subCont, "heeeer");
          } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
              }
            }
            setTableData6([]);
          } finally {
            setIsLoading(false);
          }
        };

          useEffect(() => {
            if (TOKEN && provinceID) {
              fetchSubProvinces(provinceID);
            }
          }, [TOKEN, provinceID]);

           const fetchSubRegions = async (selectedRegion) => {
              setIsLoading1(true);
          
              try {
                const response = await axios.get(`${BASE_URL1}/regions/getprovincesregion?region_id=${selectedRegion}`,
                  {
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${TOKEN}`,
                    },
                  });
          
                // console.log(response);
                const subReg = response.data?.data;
                const optionsss = subReg.map((item) => ({
                  label: item.description,
                  value: item.id,
                }));
                setTableData5(optionsss);
                // console.log(subCont, "heeeer");
              } catch (error) {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                  if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                  } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                  } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                  }
                }
                setTableData5([]);
              } finally {
                setIsLoading1(false);
              }
            };

            useEffect(() => {
                if (TOKEN && selectedRegion) {
                  fetchSubRegions(selectedRegion);
                }
              }, [TOKEN, selectedRegion]);

            useEffect(() => {
                if (TOKEN && selectedProvince) {
                  fetchSubProvinces(selectedProvince);
                }
              }, [TOKEN, selectedProvince]);

 



  const handleTypeChange = (event) => {
    console.log(event.target)
    setSelectedType(event.target.value);
  };

  // Fetch continents for React Select
   const fetchContinents = async () => {
      setIsLoading1(true);
  
      try {
        const response = await axios.get(`${BASE_URL1}/continents`, 
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TOKEN}`,
            },
          }
        );
  
        // console.log(response);
        const resultsss = response.data?.data;
        const options = resultsss.map((item) => ({
          label: item.description,
          value: item.id,
        }));
        setContinents(options);
        // console.log(results);
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setContinents([]);
      } finally {
        setIsLoading1(false);
      }
    };
    useEffect(() => {
      if (TOKEN) {
        fetchContinents();
      }
    }, [TOKEN]);

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    setRegionLoading(true);
    try {
      let regionsData = [];

      if (continentId === 'all' || !continentId) {
        setRegions([{ label: "All Regions", value: "all" }]);
        return;
      }

      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...options
      ];

      setRegions(regionsWithAll);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([{ label: "All Regions", value: "all" }]);
    } finally {
      setRegionLoading(false);
    }
  };

  const fetchProvinces = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );
      console.log(response, "fullreponse");
      const provData = response?.data.data || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvinces(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Fetch regions for modal
  const fetchRegionsModal = async (continentId) => {
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      const regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setRegionsModal(options);
    } catch (error) {
      console.error("Error fetching regions for modal:", error);
      setRegionsModal([]);
    }
  };

  const fetchProvincesModal = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );

      console.log("Provinces Modal Response:", response);
      const provData = response?.data?.data  || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvincesModal(options);
    } catch (error) {
      console.error("Error fetching provinces for modal:", error);
      setProvincesModal([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Filter handlers
  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion(null);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchRegions(selectedOption.value);
    } else {
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvinces(selectedOption.value);
    } else {
      setProvinces([]);
    }
  };

  const handleProvinceChange = (selectedOption) => {
    console.log("Selected Province:", selectedOption);
    setSelectedProvince(selectedOption.value);
  };

  // Modal filter handlers
  const handleContinentChangeModal = (selectedOption) => {
    setSelectedContinentModal(selectedOption);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    if (selectedOption) {
      fetchRegionsModal(selectedOption.value);
    }
  };

  const handleRegionChangeModal = (selectedOption) => {
    console.log("Selected Region Modal:", selectedOption);
    setSelectedRegionModal(selectedOption);
    setSelectedProvinceModal(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvincesModal(selectedOption.value);
    } else {
      setProvincesModal([]);
    }
  };

  const handleProvinceChangeModal = (selectedOption) => {
    console.log("Selected Province Modal:", selectedOption);
    setSelectedProvinceModal(selectedOption);
  };

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      // fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      // fetchUsers(currentPage);
      fetchData1();
     
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);


  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    resetNewUserForm();
  };

  const handleShowCreateUserModal = () => {
    setShowCreateUserModal(true);
    setModalError("");
  };


  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            {/* <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td> */}
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };



  const handleTransferProcess = async () => {
      setProcessLoading(true);
  
      try {
        // We use POST for transfers/updates
        const response = await axios.post(`${BASE_URL1}/parishes/transfer_parish_to_province`, 
          // 1. THE DATA BODY (The Parameters)
          {
            parish_id: transferParishId,
            // province_id: selectedProvince.value, 
            province_id: selectedProvince, 
            zone_id: selectedZone,
            area_id: selectedArea
          },
          // 2. THE HEADERS
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${TOKEN}`
            }
          }
        );
  
        // Success Logic
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message || 'Parish transferred successfully!',
        });
  
        // Close modal and refresh the main table data
        setShowTransferModal(false);
        // Optional: Reset the transfer ID
        setTransferParishId(null); 
           fetchAll(); 
      
  
      } catch (error) {
        // Error Logic (Copied from your sample)
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            // This handles the validation object you showed me
            // e.g. { province_id: ["Please select..."], ... }
            const messages = Object.values(error.response.data.message).flat();
            errorMessage = messages.join('\n');
          }
        }
  
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
      } finally {
        setProcessLoading(false);
      }
  };


  const [createLoading, setCreateLoading] = useState(false);

  const createUser = async () => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const payload = {
        name: fullName,
        email: email,
        phone_number: phone,
        type: selectedType,
        module: selectedToggle,
        permissions: selectedRoles,
        continent_id: selectedContinentModal?.value || '',
        region_id: selectedRegionModal?.value || '',
        province_id: selectedProvinceModal?.value || ''
      };

      console.log("Create User Payload:", payload);

      const response = await axios.post(
        `${BASE_URL}/users/create-new`,
        payload,
        { headers }
      );

      // fetchUsers();
      handleCloseCreateUserModal();
      resetNewUserForm();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const toIdArray = (val, key = "id") => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(x => (typeof x === "object" ? x[key] : x));
    if (typeof val === "object" && Array.isArray(val[key])) return val[key];
    if (typeof val === "number" || typeof val === "string") return [Number(val)];
    return [];
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

  const handleOpenEdit = async (user) => {
    setEditingUser(user);

    // Basic info
    setFullName(user.name || user.full_name || "");
    setEmail(user.email || "");
    setPhone(user.phone_number || user.phone || "");
    setSelectedType(String(user.user_type_id || user.type_id || user.type || ""));

    // Set React Select values for modal
    if (user.continent_id || user.continent?.id) {
      const continentOption = continents.find(c => c.value == user.continent_id || c.value == user.continent?.id);
      setSelectedContinentModal(continentOption);
      if (continentOption) {
        await fetchRegionsModal(continentOption.value);
      }
    }

    if (user.region_id || user.region?.id) {
      const regionOption = regionsModal.find(r => r.value == user.region_id || r.value == user.region?.id);
      setSelectedRegionModal(regionOption);
      if (regionOption) {
        await fetchProvincesModal(regionOption.value);
      }
    }

    if (user.province_id || user.province?.id) {
      const provinceOption = provincesModal.find(p => p.value == user.province_id || p.value == user.province?.id);
      setSelectedProvinceModal(provinceOption);
    }

    // Modules and Roles
    const userModuleIds = toIdArray(user.modules) || toIdArray(user.module_ids) || toIdArray(user.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));

    const userRoleIds = toIdArray(user.roles) || toIdArray(user.role_ids) || toIdArray(user.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));

    setShow1(true);
  };
  // Update the reset function to include all fields
  const resetNewUserForm = () => {
    setFullName("");
    setFullName1("");
    setEmail("");
    setEmail1("");
    setPhone("");
    setPhone1("");
    setSelectedType("");
    setModalError("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    setToggleStates({});
    setRoleStates({});
    setCheckAll(false);
    setRoleCheckAll(false);
  };

 
  const fetchAllZones = async (selectedRegion) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/provinces/getzonesprovince?province_id=${selectedRegion}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const zoneList = response.data?.data || [];
      const formatted = zoneList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setZones(formatted);
  
      // 🚀 After zones load, fetch areas for the first zone
      // if (formatted.length > 0) {
      //   fetchAllAreas(formatted[0].value);
      // }
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
          setZones([]);
        } finally {
      setProvLoading(false);
    }
  };
  
  
  const fetchAllAreas = async () => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };

  const fetchAllAreas1 = async () => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone1}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas1(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas1([]);
    } finally {
      setAreaLoad(false);
    }
  };
  

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchAllZones(selectedRegion);
      
    }
  }, [TOKEN, selectedRegion]);

  useEffect(() => {
    if (TOKEN && selectedZone) {
      fetchAllAreas(selectedZone);
    }
  }, [TOKEN, selectedZone]);

  useEffect(() => {
    if (TOKEN && selectedZone1) {
      fetchAllAreas1(selectedZone1);
    }
  }, [TOKEN, selectedZone1]);

  const handleProcess = async () => {
    setProcessLoading(true);

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-type?continent_id=${continentID}&region_id=${regionID}&province_id=${provinceID}&page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        // params: {
        //   zone_id: zones.id || '',
        //   area_id: selectedArea || ''
        // }
      });

       const results = response.data?.data?.parishes?.data;
      setTableData(results);
      const resultx = response.data?.data?.parishes?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.parishes?.last_page || 1;
      setTotalPages(total);

      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Failed',
      //   text: errorMessage,
      // });
    } finally {
      setProcessLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN, continentID, regionID, provinceID) {
      handleProcess();
    }
  }, [TOKEN, continentID, regionID, provinceID]);

  const fetchAll = async () => {
    setProcessLoading1(true);
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-param?continent_name=${continentName}&region_name=${regionName}&province_name=${provinceName}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        
      });

      const results = response.data?.data.data || [];

  
      setTableData1(results);
      setTotalEntries(results.length);
      setTotalPages(1);
      // setTotalEntries(formatted.length); // For display text if needed
      setTotalPages(1);
     
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

    } finally {
      setProcessLoading1(false);
    }
  };

     

   const handleAreaProcess = async () => {
    setLoading(true);
  

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-all?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          zone_id: selectedZone1 || '',
          area_id: selectedArea1 || ''
        }
      });

      const results = response.data?.data?.data;
      setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };


  const handleAreaProcess1 = async () => {
    setProcessLoading(true);

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get_by_province?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          // continent_id: selectedContinent || '',
          // region_id: selectedRegion || '',
          province_id: selectedProvince || ''
          // zone_id: selectedZone || '',
          // area_id: selectedArea || ''
        }
      });

      const results = response.data?.data?.data;
      setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setProcessLoading(false);
    }
  };

   // UPDATED: UseEffect for default fetchAll (only when fetchMode is 'default')
   useEffect(() => {
    if (TOKEN && continentName && regionName && provinceName && fetchMode === 'default') {
      fetchAll();
    }
  }, [TOKEN, continentName, regionName, provinceName]);
  // REMOVED: useEffect for handleProcess (no longer auto-called)
  // NEW: useEffect to refetch when currentPage changes in 'area' mode
  useEffect(() => {
    if (fetchMode === 'area') {
      handleAreaProcess();
      handleAreaProcess1();
    }
  }, [fetchMode]);



  const handleArea = (selectedOption) => {
    setSelectedArea(selectedOption.value);
    if (!selectedOption.value) {
      setFetchMode('default');
      fetchAll();
    }
  };
  const handleArea1 = (selectedOption) => {
    setSelectedArea1(selectedOption.value);
    if (!selectedOption.value) {
      setFetchMode('default');
      fetchAll();
    }
  };

  const handleZone = (selectedOption) => {
    setSelectedZone(selectedOption.value);
    if (!selectedOption.value) {
      setFetchMode('default');
      fetchAll();
    }
  };
  const handleZone1 = (selectedOption) => {
    setSelectedZone1(selectedOption.value);
    if (!selectedOption.value) {
      setFetchMode('default');
      fetchAll();
    }
  };



  // FIXED: Use permissions state instead of undefined variable
  useEffect(() => {
    if (!editingUser || !permissions.length) return;
    const userModuleIds = toIdArray(editingUser.modules) || toIdArray(editingUser.module_ids) || toIdArray(editingUser.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));
  }, [permissions, editingUser]);

  useEffect(() => {
    if (!editingUser || !roles.length) return;
    const userRoleIds = toIdArray(editingUser.roles) || toIdArray(editingUser.role_ids) || toIdArray(editingUser.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));
  }, [roles, editingUser]);

  const updateUser = async (user) => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const response = await axios.post(
        `${BASE_URL}/users/update-user`,
        {
          name: fullName,
          email: email,
          phone_number: phone,
          type: selectedType,
          module: selectedToggle,
          permissions: selectedRoles,
          continent_id: selectedContinentModal?.value,
          region_id: selectedRegionModal?.value,
          province_id: selectedProvinceModal?.value,
          user_id: editingUser.id
        },
        { headers }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      handleClose1();
      resetNewUserForm();
      // fetchUsers();

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleViewFixed = async (id) => {
    setSelectedItemId(id);
    setViewLoading(true);
    console.log(id);
    try {
      const response = await axios.get(`${BASE_URL1}/fixedassets/get-by-type?parish_id=${id}`,

        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
          }
        });

      const instructionData1 = response.data?.data?.assets?.data;
      setResponseData(instructionData1);
      const resultx = response.data?.data?.assets?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.assets?.last_page || 1;
      setTotalPages(total);
      console.log(instructionData1, "Am here")

      navigate('/fixed_assets_registers', { state: { parishID: id } });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

    } finally {
      setViewLoading(false);
    }
  }

  const datatoRender = useMemo(() => {
    return fetchMode === 'area' ? tableData : tableData1;
  }, [fetchMode, tableData, tableData1]);

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New User & Assign Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>

              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of your modal content (permissions, roles, etc.) */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={createUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Creating...</> : "Save User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal show={show1} onHide={handleClose1} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update User & Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of edit modal content */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={updateUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Updating...</> : "Update User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal 
        show={showTransferModal} 
        onHide={handleCloseModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Transfer Parish</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <div 
            className={classes.gridmain} 
            style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', // Forces 3 columns
              gap: '20px', 
              alignItems: 'end' 
            }}
          >
      
            {/* 1. Continent */}
            <div>
              <Form.Label className={classes.filterLabel}>Continent</Form.Label>
              <Select
                // FIX: Matches your ID state (e.g., 7) to the Object (e.g., {value: 7, label: 'Africa'})
                // value={continents.find(opt => opt.value === selectedContinent) || null}
                
                onChange={(selectedOption) => handleContinentChange(selectedOption)}
                options={continents}
                placeholder="Select Continent"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
      
            {/* 2. Region */}
            <div>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                // value={tableData4.find(opt => opt.value === selectedRegion) || null}
                
                onChange={(selectedOption) => handleRegionChange(selectedOption)}
                options={tableData4}
                isDisabled={!selectedContinent}
                placeholder="Select Region"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
      
            {/* 3. Province */}
            <div>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                // value={tableData5.find(opt => opt.value === selectedProvince) || null}
                
                onChange={(selectedOption) => handleProvinceChange(selectedOption)}
                options={tableData5}
                placeholder="Select Province"
                isDisabled={!selectedRegion}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
      
            {/* 4. Zone */}
            <div>
              <Form.Label className={classes.filterLabel}>Zone</Form.Label>
              <Select
                // value={zones.find(opt => opt.value === selectedZone) || null}
                
                onChange={(selectedOption) => handleZone(selectedOption)}
                options={zones}
                placeholder="Select Zone"
                isDisabled={!selectedProvince}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
      
            {/* 5. Area */}
            <div>
              <Form.Label className={classes.filterLabel}>Area</Form.Label>
              <Select
                // value={areas.find(opt => opt.value === selectedArea) || null}
                
                placeholder='Select Area'
                onChange={(selectedOption) => handleArea(selectedOption)}
                options={areas}
                isDisabled={!selectedZone}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
      
            {/* 6. Process Button */}
            <Button
              style={{ 
                borderRadius: 5, 
                background: "#092147", 
                width: "100%", 
                height: "38px" 
              }} 
              onClick={handleTransferProcess} 
            >
              {processLoading ? (
                <>
                  <Spinner size='sm' />
                  <span style={{ marginLeft: '5px' }}>Processing...</span>
                </>
              ) : (
                "Process Transfer"
              )}
            </Button>
      
          </div>
        </Modal.Body>
      </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>
        {/* <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div> */}

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Parish</h3>
        <p className={classes.prgText}>View All Parish.</p>

        <div className={classes.subContainer} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between', marginBottom: '-17px', marginTop: '30px' }}>
        {admin !== "Compliance" && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}>
            
          <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Zones</Form.Label>
              <Select
                  onChange={(selectedOption) => 
                  handleZone1(selectedOption)}
                  options={tableData6}
                placeholder="Select Area"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
            
            
            {/* Area Filter */}
            <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Area</Form.Label>
              <Select
                  onChange={(selectedOption) => handleArea1(selectedOption)}
                  options={areas1}
                placeholder="Select Area"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <Button
                                style={{ borderRadius: 5, marginLeft: "10px", marginTop: "26px", background: "#092147",  }} onClick={() => {
                                  setFetchMode('area');
                                  // setCurrentPage(1);
                                  handleAreaProcess();
                                }} >
                                {loading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button>

            {/* Region Filter */}
            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}
          </div>
        )}

        {admin === "Compliance" && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}>
            {/* Continent Filter */}
            <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Continent</Form.Label>
              <Select
                  onChange={(selectedOption) => handleContinentChange(selectedOption)}
                  options={continents}
                placeholder="Select Continents"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

             {/* Region Filter */}
            <div 
            // style={{ minWidth: '150px' }}
            >
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <div 
            // style={{ minWidth: '150px' }}
            >
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <Button
                                style={{ borderRadius: 5, marginLeft: "10px", marginTop: "26px", background: "#092147",  }} onClick={() => {
                                  setFetchMode('area');
                                  // setCurrentPage(1);
                                  handleAreaProcess1();
                                }} >
                                {loading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button>

            {/* Region Filter */}
            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}
          </div>
        )}

          {/* <div className={classes.statCount} style={{ flexShrink: 0, margin: '0 auto', marginRight: '5%' }}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Users</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{users.length}</p>
              )}
            </div>
          </div> */}

          {/* <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0 }}> */}

            {/* <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search users..."
              />
              <Search className={classes.searchIcon} size={16} />
              {searchLoading && (
                <div className={classes.searchSpinner}>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{
                      width: '16px',
                      height: '16px'
                    }}
                  />
                </div>
              )}
            </div> */}

            {/* Print View Button */}
            {/* <div>
              <button className={classes.loanBtn} onClick={handlePrintView}>
                <MdPrint size={18} style={{ marginRight: '2px' }} />
                Print
              </button>
            </div> */}

            {/* Add New User Button */}
            {/* <div>
              <button className={classes.loanBtn} onClick={handleShowCreateUserModal}>
                <img src={plus} alt="plus" />New User
              </button>
            </div>
          </div> */}
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                  <th>Parish Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    {/* <th>Province</th> */}
                   {/* <th>Area</th>
                  <th>Zone</th> */}
                    <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {processLoading1 || processLoading || loading ? (
                <SkeletonLoader />
              ) : datatoRender.length > 0 ? (
                datatoRender.map((item, index) => (
                  <tr style={{fontSize: "12px"}} key={item.id || index}>
                    
                  <td>{index + 1}</td>
                                                <td>{item.description}</td>
                                                <td>{formatDate(item.created_at)}</td>
                                                <td>{formatDate(item.updated_at)}</td>
                                                {/* <td>{item.province?.description}</td>
                                        <td>{item.area?.description}</td>
                                        <td></td> */}
                                                <td style={{ whiteSpace: 'nowrap' }}>

                                                  <div className="btn btn-success-soft btn-sm mr-1" style={{ backgroundColor: "#28a7451a", color: "green", }} onClick={() => handleViewFixed(item.id,item.description)}>
                                                    {/* <label htmlFor="fileInput" style={{ cursor: 'pointer' }} > */}
                                                    {viewLoading && selectedItemId === item.id ? (
                                                      <Spinner size='sm' />
                                                    ) : (
                                                      // <GrView style={{width: 20, height: 20}}/>
                                                      "View Asset"
                                                    )}
                                                    {/* </label> */}
                                                  </div>
                                                  <div 
  className="btn btn-success-soft btn-sm mr-1" 
  style={{ 
    backgroundColor: "#2828a71a", 
    color: "blue", 
    marginLeft: 10, 
    cursor: "pointer" 
  }}
  onClick={() => handleOpenModal(item)}
>
  Transfer Parish
</div>

                                                </td>
                  </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No area found matching "${searchTerm}"` : "No area available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} entries
          </p>
        </div>
      </div>
    </div>
  )
}

export default ManageParish;